import type { BedrockMessage } from '@/utils/beemAgentTypes';

// How a question that failed reads in the conversation.
export const errorReply = (detail: string): BedrockMessage => ({
  role: 'assistant',
  content: [{ text: `Sorry, I wasn't able to process your request. [Error: ${detail}]` }],
});

// What a stopped question's answer reads as: whatever the agent had written before the stop,
// then a marker. A reply is always kept, even with nothing written yet, so the conversation never
// holds two questions in a row, which the agent rejects.
export const stoppedReply = (partial: string): BedrockMessage => {
  const text = partial.trim();
  return {
    role: 'assistant',
    content: [{ text: text ? `${text}\n\n_Stopped._` : '_Stopped before answering._' }],
  };
};
